import React from 'react';
import './Telecom.css'; // Reusing the same CSS
import TelecomImage1 from '../Assets/telecom1.jpg'; // Main image
import TelecomImage2 from '../Assets/telecom2.jpg'; // Key Features
import TelecomImage3 from '../Assets/telecom3.jpg'; // How it Works
import TelecomImage4 from '../Assets/telecom4.jpg'; // Why Choose
import TelecomImage5 from '../Assets/telecom5.jpg'; // Industries

const Telecom = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">TELECOM MONITORING SYSTEM</h1>
                    <p className="FMS-description">
                        A Telecom Monitoring System provides real-time visibility and control over telecom infrastructure, enabling operators to monitor tower conditions, power systems, environmental factors, and network health. This system integrates sensors, remote communication, and analytics to ensure uptime and efficiency.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={TelecomImage1} alt="Telecom Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section */}
            <div className="FMS-content-container">
                <div className="FMS-text">
                    <p className="FMS-description">
                        The Telecom Monitoring System ensures proactive maintenance with real-time alerts, performance tracking, and intelligent reporting. Access insights remotely, manage energy usage, and receive automated failure alerts to minimize downtime.
                    </p>
                </div>

                <div className="FMS-image-container">
                    <img src={TelecomImage2} alt="Telecom Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            <div className="FMS-content-container">
                <div className="FMS-image-container">
                    <img src={TelecomImage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                <div className="FMS-text">
                    <p className="FMS-description">
                        The system collects data from sensors installed at telecom sites, including power status, temperature, battery levels, and signal strength. This data is transmitted to a central dashboard via GSM or internet for live monitoring. The analytics engine identifies issues like power outages, generator failures, or signal drops for timely response.
                    </p>
                </div>
            </div>

            {/* Why Choose */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Telecom Monitoring System</h2>
            </div>

            <div className="FMS-content-container">
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Telecom Monitoring System provides unmatched reliability and customization for your operational needs. Key benefits include:
                        <ul>
                            <li>24/7 remote site visibility</li>
                            <li>Real-time power and signal monitoring</li>
                            <li>Custom alerts for quick action</li>
                            <li>Reduced maintenance and fuel costs</li>
                            <li>Centralized dashboard with analytics</li>
                        </ul>
                    </p>
                </div>

                <div className="FMS-image-container">
                    <img src={TelecomImage4} alt="Why Choose" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Industries Using Our Telecom Monitoring System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Telecom Monitoring System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                <div className="FMS-image-container">
                    <img src={TelecomImage5} alt="Industries" className="FMS-image smaller-size" />
                </div>

                <div className="FMS-text">
                    <p className="FMS-description">
                        The Telecom Monitoring System is vital for industries that rely on continuous network uptime and remote site management:
                        <ul>
                            <li>Telecom Operators</li>
                            <li>Network Infrastructure Providers</li>
                            <li>Government Communication Services</li>
                            <li>Broadcasting Companies</li>
                            <li>Emergency Services</li>
                            <li>Rural Internet Providers</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Telecom;
